import { useState } from 'react';
import styles from './day5.module.css';

const Quiz = () => {
    return (
        <div className={styles.Quiz}>
            <p>最　　　私の　　見　けてくれるの？</p>
            <p>覚　て　ま　そうな　　わかっ　　　わかっ　　　ねえ</p>
            <p>声が　こ　る　だよ　塩辛い　が出ちゃうほど　が忘れちゃったら私は　　　なるの</p>
            <p>命のような　を見てるよ</p>
            <p>ま　ね、バ　バ　。</p>
        </div>
    );
}

export default Quiz;